import AppNavigationBar from '@rio-cloud/rio-uikit/AppNavigationBar';
import { useState } from 'react';
import { useIntl } from 'react-intl';

import { useGetStopDocumentsQuery } from '#api/documentApi.slice.ts';
import type { Document } from '#domain/Document.ts';
import { useStopsPollingWhileMounted } from '#features/documents/hooks/documentPolling.context.tsx';
import { DocumentDialog } from '#features/documents/ui/DocumentDialog.tsx';
import { DocumentsCategory } from '#features/documents/ui/Documents.tsx';
import { DocumentUploadDialog } from '#features/documents/ui/DocumentUploadDialog.tsx';

type TourStopMaterialListProps = {
    onBack: () => void;
    stopId: string;
    tourId: string;
};

export const TourStopDocumentList = ({ onBack, stopId, tourId }: TourStopMaterialListProps) => {
    const [selectedDoc, setSelectedDoc] = useState<Document | null>(null);
    const [showUploadDialog, setShowUploadDialog] = useState(false);
    const intl = useIntl();
    useStopsPollingWhileMounted(selectedDoc !== null);
    const uploadDocument = () => {
        setShowUploadDialog(true);
    };

    const { data: stopDocumentList } = useGetStopDocumentsQuery(
        { stopId: stopId },
        { refetchOnMountOrArgChange: true }
    );
    const stopDocuments = stopDocumentList?.items ?? [];

    return (
        <>
            <AppNavigationBar
                title={intl.formatMessage({
                    id: 'intl-msg:ordercom-cloud-frontend.documents.tourstop.header',
                })}
                onNavigateBack={onBack}
                className='border border-bottom-only'
            />
            <DocumentDialog
                doc={selectedDoc}
                onClose={() => {
                    setSelectedDoc(null);
                }}
            />
            <DocumentUploadDialog
                shown={showUploadDialog}
                onClose={() => setShowUploadDialog(false)}
                associations={[
                    { type: 'tour', id: tourId },
                    { type: 'tour-stop', id: stopId },
                ]}
                uploadTarget={{ tourId: tourId }}
            />
            <div className={'margin-10 gap-10 display-flex flex-column padding-bottom-15'}>
                <DocumentsCategory
                    label={intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.documents.tourstop.header',
                    })}
                    documents={stopDocuments}
                    onDocPress={value => {
                        setSelectedDoc(value);
                    }}
                    uploadDocument={uploadDocument}
                    uploadButtonTrackingKey='ordercom.tour-stop.documents.upload'
                />
            </div>
        </>
    );
};
